import { forwardRef, memo } from 'react';
import styled, { css } from 'styled-components';
import type { ITextV2Props, PredefinedV2TextVariants } from './TextV2.types';

export const typographyCss = ({
	variant,
}: {
	variant?: PredefinedV2TextVariants;
}): ReturnType<typeof css> => {
	switch (variant) {
		case 'sans/58/800':
			return css`
				font-weight: 800;
				font-size: 3.625rem;
				letter-spacing: 0;
				line-height: 4.5rem;
			`;
		case 'sans/58/600':
			return css`
				font-weight: 600;
				font-size: 3.625rem;
				letter-spacing: 0;
				line-height: 4.5rem;
			`;
		case 'sans/58/400':
			return css`
				font-weight: normal;
				font-size: 3.625rem;
				letter-spacing: 0;
				line-height: 4.5rem;
			`;
		case 'sans/58/200':
			return css`
				font-weight: 200;
				font-size: 3.625rem;
				letter-spacing: 0;
				line-height: 4.5rem;
			`;
		case 'sans/50/800':
			return css`
				font-weight: 800;
				font-size: 3.125rem;
				letter-spacing: 0;
				line-height: 4rem;
			`;
		case 'sans/50/600':
			return css`
				font-weight: 600;
				font-size: 3.125rem;
				letter-spacing: 0;
				line-height: 4rem;
			`;
		case 'sans/50/400':
			return css`
				font-weight: normal;
				font-size: 3.125rem;
				letter-spacing: 0;
				line-height: 4rem;
			`;
		case 'sans/50/200':
			return css`
				font-weight: 200;
				font-size: 3.125rem;
				letter-spacing: 0;
				line-height: 4rem;
			`;
		case 'sans/36/800':
			return css`
				font-weight: 800;
				font-size: 2.25rem;
				letter-spacing: 0;
				line-height: 3rem;
			`;
		case 'sans/36/600':
			return css`
				font-weight: 600;
				font-size: 2.25rem;
				letter-spacing: 0;
				line-height: 3rem;
			`;
		case 'sans/36/400':
			return css`
				font-weight: normal;
				font-size: 2.25rem;
				letter-spacing: 0;
				line-height: 3rem;
			`;
		case 'sans/36/200':
			return css`
				font-weight: 200;
				font-size: 2.25rem;
				letter-spacing: 0;
				line-height: 3rem;
			`;
		case 'sans/30/800':
			return css`
				font-weight: 800;
				font-size: 1.875rem;
				letter-spacing: 0;
				line-height: 2.5rem;
			`;
		case 'sans/30/600':
			return css`
				font-weight: 600;
				font-size: 1.875rem;
				letter-spacing: 0;
				line-height: 2.5rem;
			`;
		case 'sans/30/400':
			return css`
				font-weight: normal;
				font-size: 1.875rem;
				letter-spacing: 0;
				line-height: 2.5rem;
			`;
		case 'sans/30/200':
			return css`
				font-weight: 200;
				font-size: 1.875rem;
				letter-spacing: 0;
				line-height: 2.5rem;
			`;
		case 'sans/25/800':
			return css`
				font-weight: 800;
				font-size: 1.563rem;
				letter-spacing: 0;
				line-height: 2rem;
			`;
		case 'sans/25/600':
			return css`
				font-weight: 600;
				font-size: 1.563rem;
				letter-spacing: 0;
				line-height: 2rem;
			`;
		case 'sans/25/400':
			return css`
				font-weight: normal;
				font-size: 1.563rem;
				letter-spacing: 0;
				line-height: 2rem;
			`;
		case 'sans/25/200':
			return css`
				font-weight: 200;
				font-size: 1.563rem;
				letter-spacing: 0;
				line-height: 2rem;
			`;
		case 'sans/17/800':
			return css`
				font-weight: 800;
				font-size: 1.063rem;
				letter-spacing: 0;
				line-height: 1.5rem;
			`;
		case 'sans/17/600':
			return css`
				font-weight: 600;
				font-size: 1.063rem;
				letter-spacing: 0;
				line-height: 1.5rem;
			`;
		case 'sans/17/400':
			return css`
				font-weight: normal;
				font-size: 1.063rem;
				letter-spacing: 0;
				line-height: 1.5rem;
			`;
		case 'sans/17/200':
			return css`
				font-weight: 200;
				font-size: 1.063rem;
				letter-spacing: 0;
				line-height: 1.5rem;
			`;
		case 'sans/14/800':
			return css`
				font-weight: 800;
				font-size: 0.875rem;
				letter-spacing: 0;
				line-height: 1.25rem;
			`;
		case 'sans/14/600':
			return css`
				font-weight: 600;
				font-size: 0.875rem;
				letter-spacing: 0;
				line-height: 1.25rem;
			`;
		case 'sans/14/400':
			return css`
				font-weight: normal;
				font-size: 0.8rem;
				letter-spacing: 0;
				line-height: 1.25rem;
			`;
		case 'sans/14/200':
			return css`
				font-weight: 200;
				font-size: 0.875rem;
				letter-spacing: 0;
				line-height: 1.25rem;
			`;
		case 'sans/11/800':
			return css`
				font-weight: 800;
				font-size: 0.688rem;
				letter-spacing: 0;
				line-height: 1rem;
			`;
		case 'sans/11/600':
			return css`
				font-weight: 600;
				font-size: 0.688rem;
				letter-spacing: 0;
				line-height: 1rem;
			`;
		case 'sans/11/400':
			return css`
				font-weight: normal;
				font-size: 0.688rem;
				letter-spacing: 0;
				line-height: 1rem;
			`;
		case 'sans/11/200':
			return css`
				font-weight: 200;
				font-size: 0.688rem;
				letter-spacing: 0;
				line-height: 1rem;
			`;
		case 'sans/09/800':
			return css`
				font-weight: 800;
				font-size: 0.563rem;
				letter-spacing: 0;
				line-height: 0.75rem;
			`;
		case 'sans/09/600':
			return css`
				font-weight: 600;
				font-size: 0.563rem;
				letter-spacing: 0;
				line-height: 0.75rem;
			`;
		case 'sans/09/400':
			return css`
				font-weight: normal;
				font-size: 0.563rem;
				letter-spacing: 0;
				line-height: 0.75rem;
			`;
		case 'sans/09/200':
			return css`
				font-weight: 200;
				font-size: 0.563rem;
				letter-spacing: 0;
				line-height: 0.75rem;
			`;
		case 'sans/05/800':
			return css`
				font-weight: 800;
				font-size: 0.312rem;
				letter-spacing: 0;
				line-height: 0.1rem;
			`;
		default:
			return css``;
	}
};

const Text = forwardRef<HTMLSpanElement, ITextV2Props>(
	(
		{
			variant,
			className,
			children,
			i18NextInline,
			nonselectable,
			noWrap,
			multiLineElipsis,
			elipsis,
			lowercase,
			uppercase,
			capitalize,
			center,
			capitalizeFirst,
			disabled,
			onClick,
			alwaysWrap,
			'data-testid': dataTestId,
		},
		ref
	) => {
		return (
			<TextVariant
				className={className}
				disabled={disabled}
				center={center}
				capitalize={capitalize}
				noWrap={noWrap}
				lowercase={lowercase}
				uppercase={uppercase}
				capitalizeFirst={capitalizeFirst}
				multiLineElipsis={multiLineElipsis}
				elipsis={elipsis}
				i18NextInline={i18NextInline}
				nonselectable={nonselectable}
				variant={variant}
				onClick={onClick}
				alwaysWrap={alwaysWrap}
				ref={ref}
				data-testid={dataTestId}
			>
				{children}
			</TextVariant>
		);
	}
);

Text.displayName = 'Text';

// Custom style props consumed only by the CSS below — they must NOT reach the
// DOM <span> (React warns about unknown/boolean attributes like `elipsis`).
// styled-components still passes them to the template interpolations; this only
// filters what is forwarded to the underlying element.
const TEXT_STYLE_PROPS = new Set([
	'disabled',
	'center',
	'capitalize',
	'noWrap',
	'lowercase',
	'uppercase',
	'capitalizeFirst',
	'multiLineElipsis',
	'elipsis',
	'i18NextInline',
	'nonselectable',
	'alwaysWrap',
	'variant',
]);

const TextVariant = styled.span.withConfig({
	shouldForwardProp: (prop) => !TEXT_STYLE_PROPS.has(prop),
})<ITextV2Props>`
	font-weight: 400;
	display: inline-block;
	white-space: pre-line;

	${({ variant }) => typographyCss({ variant })}

	${({ nonselectable }) => (nonselectable ? 'user-select: none;' : ``)}

    ${({ i18NextInline }) =>
		i18NextInline &&
		`
        display: contents;
    `}

    ${({ multiLineElipsis }) =>
		multiLineElipsis?.enabled &&
		`
        display: -webkit-box;
        -webkit-line-clamp: ${multiLineElipsis.numberOfLines};
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-all;
        text-overflow: ellipsis;
    `}

    ${({ alwaysWrap }) => alwaysWrap && `overflow-wrap: anywhere;`}

    ${({ elipsis }) =>
		elipsis &&
		`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 1.4;
        display: block;
    `}

    ${({ uppercase }) =>
		uppercase &&
		`
        text-transform: uppercase;
    `}
    ${({ lowercase }) =>
		lowercase &&
		`
        text-transform: lowercase;
    `}
    ${({ noWrap }) =>
		noWrap &&
		`
        white-space: nowrap;
    `}
    ${({ capitalize }) =>
		capitalize &&
		`
        text-transform: lowercase;
        &:first-line {
            text-transform: capitalize;
        }
    `}
    ${({ capitalizeFirst }) =>
		capitalizeFirst &&
		`
        &:first-letter {
        text-transform: capitalize;
        }
    `}

    ${({ center }) =>
		center &&
		`
        text-align: center;
    `}

    ${({ disabled, theme }) =>
		disabled &&
		`
                color: ${theme.v2.color.neutral[500]};
        `}
`;

const Memoized = memo(Text);
const Styled = styled(Memoized)``;

export { Styled as TextV2 };
